import React from "react"
import styled from "styled-components"

import { faSpinner } from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"

import { RestAPI, RestEditorState } from "../../reducer/common.types"
import { BoldMonospace, Monospace } from "../../styles"

interface Props<E extends RestEditorState<RestAPI>> {
  state: E
  setState: (newState: E) => any

  /**
   * Whether or not we have a GET request in-flight
   * (i.e. sent a request, yet to receive a response)
   */
  pendingRequest: boolean
}

const OuterContainer = styled.div`
  display: flex;
  justify-content: space-evenly;
  flex-direction: column;
`

/**
 * Editor that lets the user construct REST
 * requests.
 */
export const RestEditor: React.SFC<Props<RestEditorState<RestAPI>>> = ({
  state,
  pendingRequest
}) => {
  return (
    <OuterContainer>
      <Monospace>Method: GET</Monospace>
      <Monospace>Domain: https://api.suredbits.com</Monospace>
      <Monospace>Path: {RestEditorState.getPath(state)}</Monospace>
      {pendingRequest ? (
        <BoldMonospace>
          Request pending <FontAwesomeIcon spin={true} icon={faSpinner} />
        </BoldMonospace>
      ) : (
        <BoldMonospace>No pending requests</BoldMonospace>
      )}
    </OuterContainer>
  )
}
